
import PaymentDialogUI from "./PaymentDialogUI"
import { Dispatch } from "redux"
import { connect } from "react-redux"
import { ActionType } from "../Actions/ActionTypes"
import PaymentDialogState from "../State/PaymentDialogState"
import ApplicationState from "../../../../../../ApplicationState"
import PaymentDialogDispatch from "./model"
import IDispatcher from "../../../../../Util/IDispatcher"
import IState from "../../../../../Util/IState"

const mapStateToProps = (state: ApplicationState): IState<PaymentDialogState> => {
    return {
        state: state.paymentDialog
    }
}

const mapDispatchToProps = (dispatch: Dispatch): IDispatcher<PaymentDialogDispatch> => ({
    dispatcher: {
        text: (txt :string) => { dispatch({ type: ActionType.AMOUNT_TEXT, text: txt }) },
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(PaymentDialogUI)